import { faCheck } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import TopBar from 'components/layout/TopBar';
import { formatError } from 'components/utils/FormatData';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { ClipLoader } from 'react-spinners';
import MyButton from '../../components/form/MyButton';
import MyForm from '../../components/form/MyForm';
import ReturnTopBar from '../../components/layout/ReturnTopBar';
import { URL_API } from '../../constants/settings';
import useWindowSize from '../../hooks/useWindowSize';


const CreateOT = (props) => {
  const alert = useAlert();
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const [width, height] = useWindowSize();
  const [loading, setLoading] = useState(false);
  const [componentHeight, setComponentHeight] = useState(height - 130);
  const [ot, setOt] = useState({
    eqpCode: '',
    prioriteCode: '',
    prioriteCodeInput: '',
    jobType: 'CU',
    conducteurCode: '',
    conducteurCodeInput: '',
    symptomeCode: '',
    commentaire: location.state?.comment ? location.state?.comment : '',
  });
  const [equipment, setEquipment] = useState();
  const [listPriorite, setListPriorite] = useState([]);
  const [listConducteurs, setListConducteurs] = useState([]);
  const [listSymptomes, setListSymptomes] = useState([]);
  const [btnCreateOtIsLoading, setBtnCreateOtIsLoading] = useState(false);
  const form = [
    {
      id: 'eqpCode',
      label: `CODE GMAO DE L'ÉQUIPEMENT`,
      required: true,
      type: 'text',
      readOnly: true,
    },
    {
      id: 'prioriteCode',
      label: `CODE PRIORITÉ DE L'OT`,
      type: 'autocomplete',
      options: listPriorite,
      inputValue: 'prioriteCodeInput',
      value: ot.prioriteCode,
    },
    {
      id: 'conducteurCode',
      label: 'CODE CONDUCTEUR',
      type: 'autocomplete',
      options: listConducteurs,
      inputValue: 'conducteurCodeInput',
      value: ot.conducteurCode,
    },
    {
      id: 'symptomeCode',
      label: 'CODE SYMPTÔME',
      type: 'autocomplete',
      options: listSymptomes,
      inputValue: 'symptomeCodeInput',
      value: ot.symptomeCode,
    },
    {
      id: 'commentaire',
      label: 'COMMENTAIRE',
      required: false,
      type: 'text',
      readOnly: false,
      multiline: true,
      maxRows: 10,
    },
  ];
  const auth = useSelector(state => state["authentification"]);

  // Chargement du composant
  useEffect(() => {
    document.title = 'SED - Création ordre de travail';

    if (auth.profil !== 1 && auth.profil !== 2 && auth.profil !== 3) {
      alert.error('Vous n\'êtes pas autorisé à accéder à cet écran');
      history.push('/');
    }
    setEquipment(location.state?.equipment);
  }, []);

  // Gestion du resize
  useEffect(() => {
    setComponentHeight(height - (110 + document.getElementById('component-topbar').clientHeight));
  }, [width, height]);

  // Chargement d'un équipement
  useEffect(() => {
    setOt({ ...ot, eqpCode: equipment ? equipment['gmaoId'] : '' });
  }, [equipment]);

  // Gestion du changement de statut WebSocket
  useEffect(() => {
    if (props.wsStatus) {
      fetchDatas();
    }
  }, [props.wsStatus]);

  const fetchDatas = () => {
    const promisePrioriteCode = axios({ method: 'get', url: URL_API + '/priorites' });
    const promiseConducteur = axios({ method: 'get', url: URL_API + '/conducteurs' });
    const promiseSymptome = axios({ method: 'get', url: URL_API + '/symptomes' });

    setLoading(true);

    Promise.all([promisePrioriteCode, promiseConducteur, promiseSymptome])
      .then(function (values) {
        setLoading(false);
        setListPriorite(values[0].data);
        setListConducteurs(values[1].data);
        setListSymptomes(values[2].data);
      })
      .catch(function (err) {
        setLoading(false);
        formatError(alert, err);
      });
  };

  const handleOnChangeValue = (value, type) => {
    setOt({ ...ot, [type]: value });
  };

  const handleOnValid = () => {
    if (ot.eqpCode && ot.prioriteCode && ot.jobType && ot.conducteurCode && ot.symptomeCode) {

      setBtnCreateOtIsLoading(true);

      if (location.state?.motif && location.state?.motif.avecCreationOT) {
        axios({ method: 'put', url: `${URL_API}/equipements/${params.id}/alarmes/acquitter?motifId=${location.state.motif.id}` })
          .then(() => {
            callApiCreateOt();
          })
          .catch((err) => {
            alert.error(`Erreur durant l'acquittement des alarmes, veuillez consulter un administrateur`);
            setBtnCreateOtIsLoading(false);
          });
      } else {
        callApiCreateOt();
      }

    } else {
      alert.error(`Vous devez renseigner l'ensemble des champs obligatoires avant de continuer`);
    }
  };

  const callApiCreateOt = () => {
    axios({
      method: 'post',
      url: URL_API + '/equipements/' +params.id + '/ots',
      data: {
        eqpCode: ot.eqpCode,
        priorite: ot.prioriteCode,
        jobType: ot.jobType,
        conducteur: ot.conducteurCode,
        symptome: ot.symptomeCode,
        commentaire: ot.commentaire,
      }
    })
      .then(function () {
        alert.success(`L'ordre de travail a été créé avec succès`);
        history.push('/equipement/' + params.id);
        setBtnCreateOtIsLoading(false);
      })
      .catch(function (err) {
        formatError(alert, err);
        setBtnCreateOtIsLoading(false);
      });
  }

  if (isMobile) {
    return (
      <div id="users" className='panel-contenu-mobile-tablette' style={{ height: height - 60 }}>
        <TopBar title="ajouter un ordre de travail" className='topbar-contenu-mobile-tablette' color={props.params.color} buttons={<ReturnTopBar url={'/equipement/' +params.id} />} />
        <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>

          <ClipLoader
            color="#0094ca"
            loading={loading}
            css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
            size={50}
          />

          {!loading &&
            <div style={{ margin: '15px', padding: '15px', width: '70%', overflow: 'auto' }}>

              <MyForm data={ot} setData={setOt} form={form} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />

              <div className="row-center" style={{ marginTop: '50px' }}>
                <MyButton
                  className="my-button"
                  type="button"
                  href="#"
                  label="VALIDER"
                  styleCss={{ backgroundColor: '#A3C745', height: '30px', color: '#ffffff' }}
                  iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                  onClick={handleOnValid}
                  isLoading={btnCreateOtIsLoading}
                />
              </div>
            </div>
          }

        </div>
      </div>
    );
  }

  return (
    <div id="users" className='panel-contenu' style={{ height: height - 110 }}>
      <TopBar title="ajouter un ordre de travail" className='topbar-contenu' color={props.params.color} buttons={<ReturnTopBar url={'/equipement/' +params.id} />} />
      <div className="composant-content-center" style={{ height: componentHeight, overflow: 'auto' }}>

        <ClipLoader
          color="#0094ca"
          loading={loading}
          css={'display: flex; position: absolute; top: 45%; left:0; right:0; margin:auto; z-index:150; justify-content: center;'}
          size={50}
        />

        {!loading &&
          <div style={{ margin: '15px', padding: '15px', width: '40%' }}>

            <MyForm data={ot} setData={setOt} form={form} onChange={handleOnChangeValue} wsStatus={props.wsStatus} />

            <div className="row-center" style={{ marginTop: '35px', padding: '15px' }}>

              {
                props.wsStatus &&
                <MyButton
                  className="my-button"
                  type="button"
                  href="#"
                  label="VALIDER"
                  styleCss={{ backgroundColor: '#A3C745', height: '30px', color: '#ffffff' }}
                  iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                  onClick={handleOnValid}
                  isLoading={btnCreateOtIsLoading}
                />
              }
              {
                !props.wsStatus &&
                <MyButton
                  className="my-button"
                  type="button"
                  href="#"
                  label="VALIDER"
                  styleCss={{ backgroundColor: '#8ca0a8', height: '30px', color: '#ffffff', cursor: 'default' }}
                  iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                  isLoading={btnCreateOtIsLoading}
                />
              }


            </div>
          </div>
        }

      </div>
    </div>
  );

};

export default CreateOT;